"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppDownloadSection;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _makealiveLogo = _interopRequireDefault(require("../../../assets/images/makealive-logo.svg"));
var _makealiveAppIcon = _interopRequireDefault(require("../../../assets/images/makealive-app-icon.png"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function AppDownloadSection(_ref) {
  let {
    i18n
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)("lightStickTutorial");
  let isIOS = window.location.search.indexOf("platform=ios") > -1;
  const DownloadBtn = _styledComponents.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0 10px;\n  "])));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: "22px",
      display: "inline-block",
      fontWeight: "500",
      lineHeight: "140%"
    }
  }, t("gallery.download"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("img", {
    style: {
      margin: "10px 5px 0 5px"
    },
    src: _makealiveLogo.default
  }), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    t: t,
    i18nKey: "gallery.app"
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      marginTop: "10px"
    },
    width: 130,
    src: _makealiveAppIcon.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: "20px",
      display: "flex",
      justifyContent: "center"
    }
  }, !isIOS ? /*#__PURE__*/_react.default.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.makerville.makealive",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(DownloadBtn, {
    width: 135,
    src: require("../../../assets/images/tutorial/".concat((i18n === null || i18n === void 0 ? void 0 : i18n.language) || "zh", "/google-play-download.png"))
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://apps.apple.com/app/id1623991918",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(DownloadBtn, {
    width: 120,
    src: require("../../../assets/images/tutorial/".concat((i18n === null || i18n === void 0 ? void 0 : i18n.language) || "zh", "/apple-store-download.png"))
  }))));
}